package pages.inbound

import ics.materialUI.components.classes.ContentFieldMapping

object InboundDetailPageFieldMappings {
    object Order {
        val orderInformationCardHeaders: Array<String> = arrayOf(
            "owner",
            "assignmentType",
            "customerReference",
            "externalReference",
            "internalReference",
            "articleCategory"
        )

        val customerInformationCardHeaders: Array<String>  = arrayOf(
            "customer",
            "customerDescription",
            "name",
            "address",
            "zipCode",
            "city",
            "city",
            "email"
        )

        val statusInformationCardHeaders: Array<String>  = arrayOf(
            "statusDescription",
            "containerAmount",
            "amountReceived",
            "amountToReceive",
            "inputDateTime",
            "endDateTime"
        )

        val extraInformationCardHeaders: Array<String>  = arrayOf(
            "explanation",
            "special",
            "webShop"
        )

        val fieldMapping: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "recordId",
                "Record id"
            ),
            ContentFieldMapping(
                "owner",
                "Owner"
            ),
            ContentFieldMapping(
                "customer",
                "Customer"
            ),
            ContentFieldMapping(
                "customerDescription",
                "Customer description"
            ),
            ContentFieldMapping(
                "customerReference",
                "Customer reference"
            ),
            ContentFieldMapping(
                "name",
                "Name"
            ),
            ContentFieldMapping(
                "address",
                "Adress"
            ),
            ContentFieldMapping(
                "zipCode",
                "Zipcode"
            ),
            ContentFieldMapping(
                "city",
                "City"
            ),
            ContentFieldMapping(
                "country",
                "Country"
            ),
            ContentFieldMapping(
                "email",
                "Email"
            ),
            ContentFieldMapping(
                "articleCategory",
                "Article category"
            ),
            ContentFieldMapping(
                "containerAmount",
                "Container amount"
            ),
            ContentFieldMapping(
                "amountReceived",
                "Amount received"
            ),
            ContentFieldMapping(
                "amountToReceive",
                "Amount to receive"
            ),
            ContentFieldMapping(
                "endDateTime",
                "End datetime"
            ),
            ContentFieldMapping(
                "inputDateTime",
                "Input datetime"
            ),
            ContentFieldMapping(
                "externalReference",
                "External reference"
            ),
            ContentFieldMapping(
                "internalReference",
                "Internal reference"
            ),
            ContentFieldMapping(
                "special",
                "Special"
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status description"
            ),
            ContentFieldMapping(
                "explanation",
                "Explanation"
            ),
            ContentFieldMapping(
                "webShop",
                "Webshop"
            ),
            ContentFieldMapping(
                "assignmentType",
                "Assignment type"
            )
        )
    }

    object OrderLines {
        val headerSequence: Array<String>  = arrayOf<String>(
            "recordId",
            "receipt",
            "article",
            "articleNumber",
            "articleDescription",
            "colorDescription",
            "articleCategory",
            "sizeCode",
            "reason",
            "returnReason",
            "statusDescription",
            "amountReceived",
            "amountExpected"
        )

        val fieldMapping: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "recordId",
                "Record Id"
            ),
            ContentFieldMapping(
                "receipt",
                "Receipt"
            ),
            ContentFieldMapping(
                "article",
                "Article"
            ),
            ContentFieldMapping(
                "articleNumber",
                "Article number"
            ),
            ContentFieldMapping(
                "articleDescription",
                "Article description"
            ),
            ContentFieldMapping(
                "articleCategory",
                "Article category"
            ),
            ContentFieldMapping(
                "colorDescription",
                "Color description"
            ),
            ContentFieldMapping(
                "sizeCode",
                "Size code"
            ),
            ContentFieldMapping(
                "reason",
                "Reason"
            ),
            ContentFieldMapping(
                "returnReason",
                "Return reason"
            ),
            ContentFieldMapping(
                "statusDescription",
                "Status description"
            ),
            ContentFieldMapping(
                "amountReceived",
                "Received amount"
            ),
            ContentFieldMapping(
                "amountExpected",
                "Expected amount"
            )
        )
    }
}